import { defineStore } from 'pinia'
import { publipostService } from '@/services/publipostService'
import errorService from '@/services/errorService'

export const usePublipostStore = defineStore('publipost', {
  state: () => ({
    allPubliposts: {
      data: {},
      meta: {},
      categories: {}
    },
    publiposts: {
      data: {},
      meta: {}
    },
    publipost: {
      meta: {
        references: []
      },
    },
    images: {},
    filter: {
      site: null,
      category: null,
      order_by: 'recent',
    },
  }),

  actions: {
    async getSharePubliposts(params, cancelToken) {
      try {
        const response = await publipostService.fetchSharePubliposts(params, cancelToken);
        this.allPubliposts = response.data;

        return { success: true };
        
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPublipostsLinks() {
      try {
        const response = await publipostService.fetchPublipostsLinks(this.filter);
        this.publipostsLinks = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPubliposts(cancelToken) {
      try {
        const response = await publipostService.fetchPubliposts(this.filter, cancelToken);
        this.publiposts = response.data;
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getStepPubliposts(cancelToken) {
      try {
        const response = await publipostService.fetchStepPubliposts(this.filter, cancelToken);
        this.stepPubliposts = response.data;

        return { success: true };

      } catch (error) {
        return errorService.handle(error);
      }
    },

    async getPublipost(id) {
    try {
        const response = await publipostService.fetchPublipost(id);
        if( response.data.data) {
          this.publipost = response.data.data;
        }
      } catch (error) {
        return errorService.handle(error);
      }
    },

    async addPublipost(params) {
      try {
        await publipostService.createPublipost(params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async updatePublipost(id, params) {
      try {
        await publipostService.updatePublipost(id, params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async uploadAttachment(params) {
      try {
        let result = await publipostService.uploadAttachment(params);
        return { success: true, image: result.data };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async generateUrl(params){
      try {
        await publipostService.generateUrl(params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async reportPublipost(id, params){
      try {
        await publipostService.reportPublipost(id, params);
        return { success: true };
      }
      catch (error) {
        return errorService.handle(error);
      }
    },

    async searchImages(params, cancelToken) {
      try {
          const response = await publipostService.searchImages(params, cancelToken);
          this.images = response.data;
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async checkPublipost(params) {
        try {
          let result = await publipostService.checkPublipost(params);
          return { success: true, sentences: result.data.sentences };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async getPublipostsRequests() {
        try {
          const response = await publipostService.fetchPublipostsRequests(this.filter);
          this.publipostsRequests = response.data;
        } catch (error) {
          return errorService.handle(error);
        }
      },

      async getPublipostRequest(id) {
        try {
            const response = await publipostService.fetchPublipostRequest(id);
            this.publipostRequest = response.data.data;
          } catch (error) {
            return errorService.handle(error);
          }
      },

      async createPublipostRequest(params) {
        try {
          await publipostService.createPublipostRequest(params);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async updatePublipostRequest(id, params) {
        try {
          await publipostService.updatePublipostRequest(id, params);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async catchPublipostRequest(id) {
        try {
          await publipostService.catchPublipostRequest(id);
          return { success: true };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },

      async generatePublipost(params) {
        try {
          let result = await publipostService.generatePublipost(params);
          return { success: true, publipost: result.data.publipost };
        }
        catch (error) {
          return errorService.handle(error);
        }
      },
  },
});